import { PDFName } from 'pdf-lib';
import { hexToRgbArray } from '../utils/color';
import { fabricToPdfCoords } from '../utils/coordinateUtils';

export function fabricArrowToPdfLine({
  page,
  fabricObject,
  basePageDimensions: { width, height },
  user_full_name,
}) {
  const { x1, y1, x2, y2, strokeWidth, stroke } = fabricObject;
  const pdfStrokeWidth = strokeWidth * 1;

  const pdfCoords = fabricToPdfCoords({
    x1,
    y1,
    x2,
    y2,
    page,
    width,
    height,
  });

  page.node.addAnnot(
    page.doc.context.obj({
      Type: 'Annot',
      Subtype: 'Line',
      Rect: pdfCoords.rect,
      L: [pdfCoords.x1, pdfCoords.y1, pdfCoords.x2, pdfCoords.y2],
      LE: [PDFName.of('None'), PDFName.of('ClosedArrow')],
      C: hexToRgbArray(stroke),
      BS: { W: pdfStrokeWidth },
      T: user_full_name,
    })
  );
}
